import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navLinks = [
  { path: '/', label: '首页' },
  { path: '/categories', label: '游戏分类' },
  { path: '/articles', label: '最新资讯' },
  { path: '/about', label: '关于我们' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => setScrolled(window.scrollY > 50);
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
  }, [location]);

  const isHome = location.pathname === '/';

  return (
    <nav
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-500 ${
        isHome && !scrolled
          ? 'bg-transparent'
          : 'bg-background-50/95 backdrop-blur-md border-b border-background-200/60'
      }`}
    >
      <div className="w-full px-4 md:px-6">
        <div className="flex items-center justify-between h-16 md:h-18">
          <Link to="/" className="flex items-center gap-3 cursor-pointer group">
            <div className="w-10 h-10 md:w-11 md:h-11 flex items-center justify-center">
              <i className={`ri-planet-line text-3xl md:text-4xl ${isHome && !scrolled ? 'text-background-50' : 'text-primary-500'} transition-colors duration-500`}></i>
            </div>
            <span className={`font-heading text-xl md:text-2xl font-bold whitespace-nowrap ${isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'} transition-colors duration-500`}>
              银河娱乐
            </span>
          </Link>

          <div className="hidden md:flex items-center gap-8">
            {navLinks.map((link) => (
              <Link
                key={link.path}
                to={link.path}
                className={`relative text-sm font-medium whitespace-nowrap cursor-pointer transition-colors duration-300 py-1 group ${
                  location.pathname === link.path
                    ? isHome && !scrolled ? 'text-background-50' : 'text-primary-500'
                    : isHome && !scrolled ? 'text-background-50/80 hover:text-background-50' : 'text-foreground-600 hover:text-foreground-900'
                }`}
              >
                {link.label}
                <span
                  className={`absolute bottom-0 left-0 h-0.5 transition-all duration-300 ${
                    location.pathname === link.path ? 'w-full bg-primary-500' : 'w-0 group-hover:w-full bg-primary-500/60'
                  }`}
                ></span>
              </Link>
            ))}
          </div>

          <div className="hidden md:flex items-center gap-3">
            <Link
              to="/about"
              className="px-5 py-2 text-sm font-medium rounded-full border cursor-pointer whitespace-nowrap transition-all duration-300 hover:scale-105"
              style={{
                borderColor: isHome && !scrolled ? 'rgba(255,255,255,0.5)' : 'oklch(var(--primary-500))',
                color: isHome && !scrolled ? '#fff' : 'oklch(var(--primary-500))',
              }}
            >
              联系客服
            </Link>
            <Link
              to="/about"
              className="px-6 py-2.5 text-sm font-bold rounded-full bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap transition-all duration-300 hover:bg-primary-600 hover:scale-105"
            >
              立即注册
            </Link>
          </div>

          <button
            onClick={() => setMobileOpen(!mobileOpen)}
            className={`md:hidden w-10 h-10 flex items-center justify-center cursor-pointer rounded-lg transition-colors ${
              isHome && !scrolled ? 'text-background-50' : 'text-foreground-900'
            }`}
            aria-label="菜单"
          >
            <i className={`text-2xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'}`}></i>
          </button>
        </div>
      </div>

      {/* Mobile menu */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-400 ${
          mobileOpen ? 'max-h-96 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-background-50/98 backdrop-blur-md border-t border-background-200/60 px-4 py-4 space-y-1">
          {navLinks.map((link) => (
            <Link
              key={link.path}
              to={link.path}
              className={`block px-4 py-3 rounded-lg text-sm font-medium transition-colors cursor-pointer ${
                location.pathname === link.path
                  ? 'bg-primary-50 text-primary-600'
                  : 'text-foreground-600 hover:bg-background-100 hover:text-foreground-900'
              }`}
            >
              {link.label}
            </Link>
          ))}
          <div className="flex gap-3 pt-3">
            <Link to="/about" className="flex-1 px-4 py-3 text-sm font-medium text-center rounded-full border border-primary-300 text-primary-500 cursor-pointer whitespace-nowrap transition-all hover:bg-primary-50">
              联系客服
            </Link>
            <Link to="/about" className="flex-1 px-4 py-3 text-sm font-bold text-center rounded-full bg-primary-500 text-background-50 cursor-pointer whitespace-nowrap transition-all hover:bg-primary-600">
              立即注册
            </Link>
          </div>
        </div>
      </div>
    </nav>
  );
}